import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickColumnsRenamer from '@/components/brick_columns_renamer.vue'

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-circle', 'text-orange']
infos.front_classes = ['fas', 'fa-file-signature', 'text-white']
infos.name = 'colrenamer'
infos.associated_class_name = 'AutomlColumnsRenamer'
infos.editing_component_name = 'BrickColumnsRenamer'
infos.editing_component = BrickColumnsRenamer
infos.descriptions = {
	en: {
		short_tooltip_description: 'Column selection',
		full_tooltip_description: 'Selects and / or renames columns',
		navbar_name: 'Column selection',
	},
	fr: {
		short_tooltip_description: 'Sélection de colonnes',
		full_tooltip_description: 'Sélectionne et / ou renomme des colonnes',
		navbar_name: 'Sélection de colonnes',
	},
}
// infos.short_tooltip_description = 'colrenamer_short_tooltip'
// infos.full_tooltip_description = 'colrenamer_full_tooltip'
// infos.navbar_name = 'colrenamer_navbar'
infos.background_color = 'orange'

brick_registerer(infos)
